import { evidenceSourceMatchesDocumentUrl } from '@/domains/report/api/evidenceSourceMatch';
import type { EvidenceItem, ValidationAnswer, ValidationReportItem } from '@/domains/report/api/types';

export type AnswerSource = {
  docId: string;
  docName: string;
  /** Alle pagina's uit de evidence, oplopend en ontdubbeld; leeg als de extractie er geen meegaf. */
  pages: number[];
  /** Passage waarop het documentdialog opent: die met de laagste pagina, bij gelijkspel de eerste. */
  evidence: EvidenceItem;
};

const lowestPage = (ev: EvidenceItem): number =>
  ev.pages && ev.pages.length > 0 ? Math.min(...ev.pages) : Number.POSITIVE_INFINITY;

/** Bronnen van één antwoord: één per document, in volgorde van eerste voorkomen in de evidence. */
export function answerSources(
  answer: ValidationAnswer,
  documents: ValidationReportItem['documents'],
): AnswerSource[] {
  const byDoc = new Map<string, { docName: string; pages: Set<number>; evidence: EvidenceItem }>();

  for (const ev of answer.evidence) {
    const doc = documents.find((d) => evidenceSourceMatchesDocumentUrl(ev.source, d.url));
    if (!doc) continue;
    const entry = byDoc.get(doc.id) ?? { docName: doc.name, pages: new Set<number>(), evidence: ev };
    for (const page of ev.pages ?? []) entry.pages.add(page);
    if (lowestPage(ev) < lowestPage(entry.evidence)) entry.evidence = ev;
    byDoc.set(doc.id, entry);
  }

  return [...byDoc].map(([docId, { docName, pages, evidence }]) => ({
    docId,
    docName,
    pages: [...pages].sort((a, b) => a - b),
    evidence,
  }));
}

/** "p. 8, 9, 12"; leeg zonder pagina's. */
export const pagesLabel = (pages: number[]): string =>
  pages.length === 0 ? '' : `p. ${pages.join(', ')}`;
